var map;
var lat = $("#contact-map").data("lat"),
    lng = $("#contact-map").data("lng");

    function initMap() {
        if ($("#contact-map").length) {
            map = new google.maps.Map(document.getElementById('contact-map'), {
                center: {lat: lat, lng: lng},
                zoom: 15,
                scrollwheel: false,
                draggable: false,
                panControl: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_CENTER
                }
            });

            var marker = new google.maps.Marker({
                position: {lat: lat, lng: lng},
                map: map
            });
        }
    }


    $(".medium").find("h4").each(function () {
        var first = $(this).text().substr(0,1),
            rest = $(this).text().substring(1);


        $(this).html(first + "<span>" + rest + "</span>")
    });


